import moment from "moment-timezone";

const getTimezone = () => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return timeZone;
  } catch (error) {
    console.error("Error retrieving timezone:", error);
  }
};

export const dateFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMMM YYYY") : "";
};

export const dayFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD") : "";
};

export const yearFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("yyyy") : "";
};

// in utc

export const dateFormatUtc = (date) => {
  const timezone = getTimezone();
  return date
    ? moment(date).tz(timezone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    : "";
};

export const dateFormatWithTime = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMM YYYY, hh:mm A") : "";
};

export const month = () => {
  return [
    { name: "January", value: "1" },
    { name: "February", value: "2" },
    { name: "March", value: "3" },
    { name: "April", value: "4" },
    { name: "May", value: "5" },
    { name: "June", value: "6" },
    { name: "July", value: "7" },
    { name: "August", value: "8" },
    { name: "September", value: "9" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];
};

export const formatToDDMMYYYY = (isoDate) => {
  return moment(isoDate).format("DD-MM-YYYY");
};
